const common = {
  "account.error.generic": "Algo salió mal mientras cargaba tu cuenta.",
  "account.error.reload": "Algo salió mal mientras cargaba tu cuenta. Haz clic en actualizar para intentarlo de nuevo.",
};

const recovery = {
  "account.recovery.user.title": "Necesitamos recuperar tu perfil",
  "account.recovery.user.message": "Falta tu registro de perfil de BeYourBest. Recupéralo ahora para seguir usando tu cuenta con normalidad.",
  "account.recovery.user.action": "Recuperar perfil",
  "account.recovery.user.loading": "Recuperando perfil...",
  "account.recovery.products.title": "Necesitamos recuperar tu acceso a la cuenta",
  "account.recovery.products.message.owner":
    "A tu cuenta le faltan registros de acceso a productos. Recupéralos ahora para cargar correctamente tus suscripciones y permisos.",
  "account.recovery.products.message.member": "Esta cuenta le faltan registros de acceso a productos. El propietario necesitará recuperarlos.",
  "account.recovery.products.action": "Recuperar acceso",
  "account.recovery.products.loading": "Recuperando acceso...",
  "account.recovery.action.error": "No pudimos completar la recuperación ahora mismo. Por favor, inténtalo de nuevo.",
  "account.recovery.action.permission-denied": "No tienes permisos para recuperar esta cuenta.",
  "account.recovery.signout": "Cerrar sesión",
};

const profileSelection = {
  "account.profile.selection.title": "Seleccionar Perfil",
  "account.profile.selection.add": "Agregar Perfil",
  "account.profile.selection.search.placeholder": "Buscar perfiles",
  "account.profile.selection.who": "¿Quién está entrenando?",
  "account.profile.selection.search.instruction": "Empieza a escribir tu nombre para encontrar rápidamente tu perfil",
};

const accountSelection = {
  "account.selection.title": "Seleccionar Cuenta",
  "account.selection.description": "Elige una cuenta para acceder a tus perfiles",
};

const addProfile = {
  "account.profile.add.title": "Agregar Miembro",
  "account.profile.add.subtitle": "Agregar un nuevo miembro a tu cuenta",
  "account.profile.add.role.label": "Rol",
  "account.profile.add.dob.label": "Fecha de Nacimiento",
  "account.profile.add.button.cancel": "Cancelar",
  "account.profile.add.button.submit": "Agregar Perfil",
  "account.profile.add.first.label": "Nombre",
  "account.profile.add.last.label": "Apellido",
};

const inviteUser = {
  "account.profile.invite.title": "Invitar Usuario",
  "account.profile.invite.subtitle": "Invitar a un usuario a unirse a tu cuenta",
  "account.profile.invite.email.label": "Correo electrónico",
  "account.profile.invite.email.placeholder": "Ingresa dirección de correo electrónico",
  "account.profile.invite.found.label": "Usuario Encontrado",
  "account.profile.invite.role.label": "Rol",
  "account.profile.invite.button.cancel": "Cancelar",
  "account.profile.invite.button.submit": "Invitar Usuario",
  "account.profile.invite.alert.existing": "Usuario existente encontrado. Se le notificará para unirse a tu cuenta.",
  "account.profile.invite.alert.new": "El nuevo usuario será invitado a unirse a tu cuenta.",
  "account.profile.invite.alert.existing.member": "Este usuario ya es miembro de tu cuenta.",
  "account.profile.invite.alert.caution":
    "Asegúrate de que has ingresado la dirección de correo electrónico correcta. Si la persona que estás invitando no recibe una invitación por correo electrónico, por favor revisa la carpeta de spam y que la dirección de correo electrónico esté correctamente escrita. De lo contrario, contacta a Be Your Best support.",
  "account.profile.invite.alert.pending": "Este usuario ya tiene una invitación pendiente para esta cuenta.",
  "account.profile.invite.success.title": "Invitación Enviada",
  "account.profile.invite.success.message":
    "Un correo electrónico con instrucciones de invitación ha sido enviado al usuario para unirse a tu cuenta. Si el usuario no recibe una invitación, por favor revisa la carpeta de spam y que la dirección de correo electrónico esté correctamente escrita. De lo contrario, contacta a Be Your Best support.",
};

const pinEntry = {
  "account.pin.locked.title": "PIN Bloqueado",
  "account.pin.locked.message.timed": "Has ingresado tu PIN incorrectamente demasiadas veces. Tu acceso al PIN se desbloqueará {{time}}.",
  "account.pin.locked.message.generic": "Has ingresado tu PIN incorrectamente demasiadas veces. Por favor, inténtalo más tarde.",
  "account.pin.locked.button.signout": "Cerrar Sesión",
  "account.pin.entry.welcome": "Bienvenido de nuevo, {{name}}",
  "account.pin.entry.instruction": "Usa el teclado numérico o tu teclado para ingresar tu PIN.",
  "account.pin.entry.title": "Ingresa tu PIN",
  "account.pin.entry.attempts": "{{count}} intento{{plural}} restante{{plural}}",
  "account.pin.entry.button.cancel": "X cancelar",
  "account.pin.entry.vr.title": "Ingresa Tu PIN",
  "account.pin.entry.vr.description": "Ingresa tu PIN de 4 dígitos para iniciar sesión",
  "account.pin.entry.vr.forgot": "¿Olvidaste tu PIN?",
  "account.pin.entry.error.unknown": "Ocurrió un error al cambiar de perfil. Por favor, inténtalo de nuevo o contacta a Be Your Best support.",
};

export const account = {
  ...common,
  ...recovery,
  ...profileSelection,
  ...accountSelection,
  ...addProfile,
  ...inviteUser,
  ...pinEntry,
};
